import { ComponentPropsWithoutRef, forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { type VariantProps } from "class-variance-authority";
import { cn } from "@/utils/tailwind";
import { badgeVariants } from "@/kit/helpers/badge";

export interface BadgeProps
  extends ComponentPropsWithoutRef<"span">, VariantProps<typeof badgeVariants> {
  asChild?: boolean;
}

export const Badge = forwardRef<HTMLElement, BadgeProps>(
  (
    {
      className,
      variant,
      size,
      shape,
      hasPrefix,
      hasSuffix,
      asChild = false,
      ...props
    },
    ref,
  ) => {
    const Comp = asChild ? Slot : "span";
    return (
      <Comp
        ref={ref}
        data-slot="badge"
        className={cn(
          badgeVariants({ variant, size, shape, hasPrefix, hasSuffix }),
          className,
        )}
        {...props}
      />
    );
  },
);
